import { Link, Outlet } from 'react-router-dom'
import Navigation from './Navigation'
import logo from './stockpiler_logo.png'
import Dropdown from 'react-bootstrap/Dropdown'
import TCFooter from './TCFooter'
import EditableNumber from '../components/EditableNumber'
import SessionExpiredPopup from '../components/SessionExpiredPopup'
import ErrorBoundary from '../components/ErrorBoundary'
import BottomNav from './BottomNav'
import PlanInfoDrawer from '../plan/PlanInfoDrawer'

export default function MainLayout({ userId, activePlan, role, activePlanName, onSubscriptionDropdownSelected, subscriptions, agreedToTerms, onAgreementSigned, mobileView,
  handleShowHideClicked, onAccountSelected, activeAccountName, accounts, accountValue, onAccountValueUpdated, isOptions, isSessionExpired, disableDate, hideAccountValues, showLegacyBottomNav
}) {
  return (
    <div>
      <SessionExpiredPopup isExpired={isSessionExpired} />
      <Navigation planId={activePlan} role={role} planName={activePlanName} userId={userId} outerContainerId={'outer-container'} pageWrapId={'page-wrap'} />

      <div className="topheader">
        <table width="100%">
          <tbody>
            <tr>
              <td align="left"><Link className="bg-transparent" to={"https://www.stockpiler.net"}><img alt="logo" src={logo} width={200} /></Link>{isOptions ? <b>OPTIONS</b> : null}</td>
              <td align="left">
                <div className='sameline' style={{ padding: '10px' }}>
                  <PlanInfoDrawer planId={activePlan} mobileView={mobileView} role={role} />
                  &nbsp;&nbsp;
                  <Dropdown onSelect={(e) => onSubscriptionDropdownSelected(e)}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                      {activePlanName}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {subscriptions.map(subscription => {
                        return (<Dropdown.Item as='planId' key={subscription.planId} eventKey={subscription.planId} value={subscription.name}>{subscription.name}</Dropdown.Item>)
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </td>
            </tr>
            {disableDate && !isNaN(Date.parse(disableDate)) ?
              <tr style={{ backgroundColor: 'yellow', textAlign: 'center' }}>
                <td colSpan={2}>
                  <div style={{ fontSize: 15, fontWeight: 'bold' }}>You account will be disabled on {new Date(disableDate).toLocaleDateString()}</div>
                </td>
              </tr>
              :
              null}
          </tbody>
        </table>
      </div>

      <main className='main-content'>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      <br></br>
      <TCFooter></TCFooter>
      <br></br>
      <br></br>
      <br></br>

      <div className="footer">
        <BottomNav
          activeAccountName={activeAccountName}
          mobileView={mobileView}
          accounts={accounts}
          onAccountSelected={onAccountSelected}
          handleMobileViewClicked={handleShowHideClicked}
          hideAccountValues={hideAccountValues}
          accountValue={accountValue}
          onAccountValueUpdated={onAccountValueUpdated}
        />
        {showLegacyBottomNav ?
          <table width="100%">
            <tbody>
              <tr>
                <td width="10%">
                  <div style={{ marginLeft: "15px" }} className="sameline">
                    <input type="checkbox" checked={mobileView} onChange={(e) => handleShowHideClicked()}></input>&nbsp;Mobile
                  </div>
                </td>
                <td width="45%" align="center" valign='top'>
                  <div className="sameline">
                    <div>
                      <Dropdown width="150" onSelect={(e) => onAccountSelected(e)}>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basick" key={activeAccountName}>
                          {activeAccountName}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="analytics_hidden" >
                          <Dropdown.Item as='selectAccount' eventKey={-1} value={-1}>Select Account...</Dropdown.Item>
                          {accounts.map(account => {
                            return (<Dropdown.Item as='accountId' key={account.idaccounts} eventKey={account.idaccounts} value={account.idaccounts}>{account.name} ({account.plan_name})</Dropdown.Item>)
                          })}
                          <Dropdown.Item as='addAccount' eventKey={-2} value={-2}><Link to="/addAccount">Manage Accounts</Link></Dropdown.Item>
                          <Dropdown.Item as='summary' eventKey={-3} value={-3}><Link to="/accountsSummary">Accounts Summary</Link></Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div >
                      Account Value: <EditableNumber hideValue={hideAccountValues} value={accountValue} onValueUpdated={onAccountValueUpdated} length="8" />
                    </div>
                  </div>
                </td>
                <td align="right" className='help-button'>
                </td>
              </tr>
            </tbody>
          </table>
          :
          null}
      </div>
    </div>
  )
}